var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 15.8333C11.666 16.75 12.416 17.5 13.3327 17.5C14.2493 17.5 14.9993 16.75 14.9993 15.8333C14.9993 14.9167 14.2493 14.1667 13.3327 14.1667C12.416 14.1667 11.666 14.9167 11.666 15.8333Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 15.8333C5.83301 16.75 6.58301 17.5 7.49967 17.5C8.41634 17.5 9.16634 16.75 9.16634 15.8333C9.16634 14.9167 8.41634 14.1667 7.49967 14.1667C6.58301 14.1667 5.83301 14.9167 5.83301 15.8333Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 4.16683C11.666 5.0835 12.416 5.8335 13.3327 5.8335C14.2493 5.8335 14.9993 5.0835 14.9993 4.16683C14.9993 3.25016 14.2493 2.50016 13.3327 2.50016C12.416 2.50016 11.666 3.25016 11.666 4.16683Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 4.16683C5.83301 5.0835 6.58301 5.8335 7.49967 5.8335C8.41634 5.8335 9.16634 5.0835 9.16634 4.16683C9.16634 3.25016 8.41634 2.50016 7.49967 2.50016C6.58301 2.50016 5.83301 3.25016 5.83301 4.16683Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 9.99984C11.666 10.9165 12.416 11.6665 13.3327 11.6665C14.2493 11.6665 14.9993 10.9165 14.9993 9.99984C14.9993 9.08317 14.2493 8.33317 13.3327 8.33317C12.416 8.33317 11.666 9.08317 11.666 9.99984Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 9.99984C5.83301 10.9165 6.58301 11.6665 7.49967 11.6665C8.41634 11.6665 9.16634 10.9165 9.16634 9.99984C9.16634 9.08317 8.41634 8.33317 7.49967 8.33317C6.58301 8.33317 5.83301 9.08317 5.83301 9.99984Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenue);
export default __webpack_public_path__ + "static/media/menue.3f3f9b60305f9982f9631900ace9547e.svg";
export { ForwardRef as ReactComponent };